import { toPrice } from '@utils'
import classNames from 'classnames'

export default function AgentSaleTotals({
  data,
  className
}) {

  return (
    <div className={classNames('justify-between items-start', className)}>
      <Item label='Listings' id={data.id}>{data.houseNum}</Item>
      <Item label='Sold properties' sub='Over the last 12 months' id={data.id}>{data.recentSoldNum}</Item>
      <Item label='Total sold properties' id={data.id}>{data.soldNum}</Item>
      <Item label='Average sale price' sub='Over the last 12 months' id={data.id} num={data.soldValue}></Item>
      {data.daysOnMarket && <Item label='Average days on market' sub='Over the last 12 months' id={data.id}>{data.daysOnMarket}</Item>}
    </div>
  )
}

function Item({
  children,
  num,
  label,
  sub,
  id
}) {

  // https://7thave.atlassian.net/browse/HT-5465
  // id是13821的情况下，num和children都为空，不显示Item
  if (id === 13821 && !num && !children) {
    return null
  }

  return (
    <div className='text-font space-y-4'>
      <div className='text-3xl font-bold'>{children ? toPrice(children, '') : (num || '-')}</div>
      <div className='text-base font-normal'>{label}</div>
      {sub && <div className='text-xs text-neutral-5'>{sub}</div>}
    </div>
  )
}